// src/utils/security.js
import { db, auth } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export const logInfraction = async (type, details) => {
  try {
    await addDoc(collection(db, 'security_logs'), {
      type,
      severity: 'CRITICAL',
      details,
      uid: auth.currentUser?.uid || 'guest',
      timestamp: serverTimestamp(),
      userAgent: navigator.userAgent, // Helpful for identifying bots
      path: window.location.pathname   // Tells you exactly where they were
    });
  } catch (err) {
    console.error("Failed to log security event:", err);
  }
};
